// Components==============
import { motion } from 'framer-motion';
import React, { useState } from 'react';
import './ToggleButton.module.scss';
// =========================

type Props = {
    onClick: () => void;
    value1: string;
    value2: string;
};

const variants = {
    left: {
        x: '0%',
    },
    right: {
        x: '100%',
    },
};
type Status = 'left' | 'right';

export default function ToggleButton(props: Props) {
    const [status, setStatus] = useState<Status>('left');

    return (
        <div
            styleName="wrapper"
            onClick={() => {
                props.onClick();
                return status === 'left'
                    ? setStatus('right')
                    : setStatus('left');
            }}
        >
            <motion.div
                initial="left"
                animate={status}
                variants={variants}
                styleName="slider"
            />
            <p styleName={`${status === 'left' ? 'active' : ''}`}>
                {props.value1}
            </p>
            <p styleName={`${status === 'right' ? 'active' : ''}`}>
                {props.value2}
            </p>
        </div>
    );
}
